import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import VueSocialSharing from 'vue-social-sharing';
import * as rules from 'vee-validate/dist/rules';
import App from './App.vue';
import Home from './Home.vue';
import Quiz from './Quiz.vue';
import LeaderBoard from './LeaderBoard.vue'
import Error from './Error.vue'
import './registerServiceWorker';
import store from './store';
import VueRouter from 'vue-router';
import { VuejsDatatableFactory } from 'vuejs-datatable';
Vue.use( VuejsDatatableFactory );

Vue.use(VueRouter);

const routes = [
    {path: '/', component: Home},
    {path: '/error', component: Error},
    {path: '/:quiz', component: Quiz},
    {path: '/:quiz/leaderboard', component: LeaderBoard},
    
];

const router = new VueRouter({
    routes,
    mode: 'history'
});

require('./assets/styles/main.scss');

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.use(VueSocialSharing);

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');


